(function () {
  'use strict';
  function connectWholesaleCard() {
    var root = document.querySelector('.section-product-template');
    if (!root || root.dataset.fxWholesalePlacementReady) return;
    root.dataset.fxWholesalePlacementReady = '1';
    var scheduled = false;

    function placeCard() {
      scheduled = false;
      var target = root.querySelector('.product-table-volume');
      if (!target) return;
      var nativeTable = root.querySelector('.samitaWS_volumeTable_product_form .samitaWS-volumeTable-widget-wrapper');
      if (nativeTable && nativeTable.parentElement !== target) target.appendChild(nativeTable);

      var card = root.querySelector('.fixoem-wholesale-widget');
      if (card && card.parentElement !== target) target.appendChild(card);
      var heading = target.previousElementSibling;
      if (card && heading && /^precio de mayoreo$/i.test(heading.textContent.trim()) && heading.style.display !== 'none') {
        heading.style.display = 'none';
      }
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(placeCard);
    }

    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    placeCard();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectWholesaleCard, { once: true });
  else connectWholesaleCard();
  document.addEventListener('shopify:section:load', connectWholesaleCard);
}());